'use strict';

import {ngDepModel} from './ngdepmodel.js';
import {sectionFieldModel} from './sectionfieldmodel.js';

export class sectionModel extends ngDepModel
{
	fields = [];
	fieldMap = {};
	nameMap = {};
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	afterSetup(data){
		if(typeof(data.fields) !== 'undefined' && data.fields.length > 0){
			let fields = [];
			
			for(let fld of data.fields){
				const key = 'f' + fld.id;
				this.fieldMap[key] = new sectionFieldModel(fld, this.s('$filter'), this.s('jsDataService'));
				fields.push(this.fieldMap[key]);
				this.nameMap[fld.name] = this.fieldMap[key];
//				fields.push(new sectionFieldModel(fld, this.s('$filter'), this.s('jsDataService')));
			}
			this.fields = fields;
		}
	}
	
	getTitleFormated(){
//		let idt = '';
		let nr = '';
//		const tim = 8;
//		const sp = '&nbsp;';
//		if(this.level > 1){
//			idt = sp.repeat(tim * (parseInt(this.level) - 1));
//		}
		if(this.numbered == 1 && this.number !== ''){
			nr = this.number + ' ';
		}
		return nr + this.title;
//		return idt + nr + this.title;
	}
}